import React from 'react';
import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer'
import styles from '../ModulosMovimientos/movimientos.module.sass'
import { MenuCredito } from 'components/menuCredito'
import { Error500 } from 'components/Error/Error500'
import { MovementsCards } from '../ModulosMovimientos'

export function MovimientosDesktop(props) {

    const {
        respMovements,
        errorCode
    } = props

    return (
        <>
            <Header type="complete" />
            <main>
                <section className="sectionPrincipal">
                    <MenuCredito />
                    {errorCode >= 500
                        ? <Error500 />
                        : respMovements
                            ?
                                <div className={styles?.contentSection}>
                                    <h1 className={styles?.h1Title}>Movimientos</h1>
                                    <MovementsCards respMovements={respMovements} />
                                </div>
                            : null
                    }
                </section>
            </main>
            <Footer type="complete" />
        </>
    )
}